import { useRef, useState } from "react";
import PropTypes from "prop-types";
import { replace } from "lodash";
import Section from "./Section";
import { PERIOD_OPTIONS } from "./HeadingSelect";
import Goal from "./Goal";
import Loader from "./Loader";
import useGoals, { goalValueToYearly } from "../services/useGoals";
import SectionHeader from "./SectionHeader";

const TeamActivityGoals = ({ year, isAdmin, refreshKey, workingMonths }) => {
  const teamActivityFormRef = useRef(null);
  const [period, setPeriod] = useState(PERIOD_OPTIONS[0]);
  const [isEditing, setIsEditing] = useState(false);
  const teamActivityGoals = useGoals({
    year,
    period,
    section: "team_activity",
    load: isAdmin,
    reloadKey: refreshKey,
    workingMonths,
  });

  const submitGoals = (ref, section) => (e) => {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(ref.current));

    Object.keys(data).forEach((key) => {
      const oldGoal = section.goals[key] || { goalTypeId: key };
      const goalType = teamActivityGoals.goalTypes.find((x) => x.id === oldGoal.goalTypeId)?.name || "";
      const goal = {
        ...oldGoal,
        goalValue: goalValueToYearly(replace(data[key], /,/g, "") || 0, period, goalType, workingMonths),
        year,
      };

      if (goal.goalValue === String(oldGoal.goalValue)) return;

      if (goal.id) {
        section.actions.updateGoal(goal);
      } else {
        section.actions.createGoal(goal);
      }
    });

    setIsEditing(false);
  };

  if (!isAdmin) return null;

  return (
    <Section className="tw-basis-[500px] tw-grow" isEditing={isEditing}>
      <SectionHeader
        description="Set activity goals for your team as a whole. Note that these are automatically logged and do not require manual entry."
        isEditing={isEditing}
        name="teamActivityGoalsPeriod"
        onSubmit={(e) => {
          submitGoals(teamActivityFormRef, teamActivityGoals)(e);
        }}
        options={PERIOD_OPTIONS}
        period={period}
        setIsEditing={setIsEditing}
        setPeriod={setPeriod}
        title="Team Activity Goals"
      />

      <div className="tw-flex flex tw-flex-col tw-relative">
        <div className="tw-flex tw-justify-between tw-flex-wrap tw-gap-[16px]">
          <form ref={teamActivityFormRef} className="tw-flex tw-flex-col tw-grow">
            {teamActivityGoals.goalTypes.map((goalType) => (
              <Goal
                key={goalType.id}
                isEditing={isEditing}
                goalType={goalType}
                goal={teamActivityGoals.goals[goalType.id]}
                onChange={() => {}}
              />
            ))}
          </form>
        </div>

        {teamActivityGoals.loading && <Loader />}
      </div>
    </Section>
  );
};

TeamActivityGoals.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  refreshKey: PropTypes.number,
  workingMonths: PropTypes.number,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

TeamActivityGoals.defaultProps = {
  refreshKey: 0,
  workingMonths: 12,
};

export default TeamActivityGoals;
